module.exports = __webpack_public_path__ + "static/img/crm5.43e8c6d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/crm5.png
// module id = to9w
// module chunks = 73